import { DtoRequestRwdacctsPostReq } from "./abst/DtoRequestRwdacctsPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestRwdacctsPostReqImple extends DtoRequestRwdacctsPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
